import React from 'react';

// Cancellation & Transfer policy shown at checkout for live-webinar (cohort)
// purchases. Live cohorts are "all sales final" with a transfer/credit path,
// so buyers must see these terms before paying.
export default function LiveCohortPolicy() {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-5 text-sm text-amber-900">
      <h3 className="font-semibold text-amber-900">Cancellation &amp; Transfer Policy</h3>
      <p className="mt-2">
        <span className="font-semibold">All sales are final.</span> If you are unable to attend your
        selected cohort, you may transfer your enrollment to a future available cohort at no charge.
        Transfer requests must be submitted to{' '}
        <a href="mailto:manager@123ceu.com" className="font-medium underline hover:text-amber-950">
          manager@123ceu.com
        </a>{' '}
        at least 7 days before your first session. Transfers are subject to cohort availability. If
        your preferred month is not yet scheduled, your credit will be held and applied when you
        re-enroll — simply email us when you&rsquo;re ready. Credits are valid for 12 months from the
        original purchase date.
      </p>
      <p className="mt-2">
        <span className="font-semibold">Important:</span> No-shows are not eligible for transfers or
        credits. If you do not attend your scheduled cohort without prior notice, a new purchase is
        required to enroll in a future cohort.
      </p>
    </div>
  );
}
